import React from 'react';

import { DateField, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import DiffFieldLayout from './DiffFieldLayout';

const DateDiffField = ({
  source,
  label,
  showTime = false,
  options,
}: {
  source: string;
  label: string;
  showTime?: boolean;
  options?: Intl.DateTimeFormatOptions;
}) => {
  const record = useRecordContext();

  const oldValue = get(record, `${source}.oldRawValue`);
  const newValue = get(record, `${source}.newRawValue`);

  return (
    <DiffFieldLayout
      label={label}
      oldElement={(
        <DateField
          record={{ value: oldValue }}
          source="value"
          emptyText="-"
          showTime={showTime}
          options={options}
        />
      )}
      newElement={(
        <DateField
          record={{ value: newValue }}
          source="value"
          emptyText="-"
          showTime={showTime}
          options={options}
        />
      )}
    />
  );
};

export default DateDiffField;
